module.exports = __webpack_public_path__ + "img/center_left.509ae7bb.svg";